/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface GuidedSailTimeSlot
 */
export interface GuidedSailTimeSlotOptional {
  /**
   * Start time in format HH:mm
   * @type {string}
   * @memberof GuidedSailTimeSlot
   */
  startTime?: string;
  /**
   * End time in format HH:mm
   * @type {string}
   * @memberof GuidedSailTimeSlot
   */
  endTime?: string;
}

export interface GuidedSailTimeSlot extends GuidedSailTimeSlotOptional {
  /**
   * Start time in format HH:mm
   * @type {string}
   * @memberof GuidedSailTimeSlot
   */
  startTime: string;
  /**
   * End time in format HH:mm
   * @type {string}
   * @memberof GuidedSailTimeSlot
   */
  endTime: string;
}

export interface GuidedSailTimeSlotTrackedI {
  /**
   * Start time in format HH:mm
   * @type {string}
   * @memberof GuidedSailTimeSlot
   */
  startTime?: string;
  startTimeIsSet: boolean;
  /**
   * End time in format HH:mm
   * @type {string}
   * @memberof GuidedSailTimeSlot
   */
  endTime?: string;
  endTimeIsSet: boolean;
}

transformDatesMap.set(
  "GuidedSailTimeSlot",
  function (model: GuidedSailTimeSlot) {},
);

export type GuidedSailTimeSlotMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  startTime: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  endTime: PropertyMeta<MetaTypeBase<string>>;
}>;

export var GuidedSailTimeSlotMeta: GuidedSailTimeSlotMetaI =
  {} as GuidedSailTimeSlotMetaI;
GuidedSailTimeSlotMeta = typeMeta("GuidedSailTimeSlot", {
  startTime: propertyMeta(
    "startTime",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  endTime: propertyMeta("endTime", false, true, false, MetaTypesBase.string),
});

const metaI = GuidedSailTimeSlotMeta;

registerMeta(() => {});

export class GuidedSailTimeSlotTracked implements GuidedSailTimeSlotTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  startTime__I?: string = undefined;
  startTimeIsSet: boolean = false;
  set startTime(v: undefined | string) {
    if (v !== undefined) {
      this.startTime__I = v;
      this.startTimeIsSet = true;
    } else {
      this.startTime__I = v || undefined;
      this.startTimeIsSet = true;
    }
    this.changeTracker = true;
  }
  get startTime() {
    return this.startTime__I;
  }
  endTime__I?: string = undefined;
  endTimeIsSet: boolean = false;
  set endTime(v: undefined | string) {
    if (v !== undefined) {
      this.endTime__I = v;
      this.endTimeIsSet = true;
    } else {
      this.endTime__I = v || undefined;
      this.endTimeIsSet = true;
    }
    this.changeTracker = true;
  }
  get endTime() {
    return this.endTime__I;
  }
  constructor(config?: GuidedSailTimeSlotOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: GuidedSailTimeSlotOptional,
    options?: AssignOptions,
  ): GuidedSailTimeSlotTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.startTime && this.startTimeApplyFilter(optionsRequired.filter)) {
      this.startTime = config.startTime;
      if (optionsRequired.unassign) this.startTimeIsSet = false;
      else this.startTimeIsSet = true;
    }
    if (config.endTime && this.endTimeApplyFilter(optionsRequired.filter)) {
      this.endTime = config.endTime;
      if (optionsRequired.unassign) this.endTimeIsSet = false;
      else this.endTimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): GuidedSailTimeSlotTrackedI {
    const cloned = {} as GuidedSailTimeSlotTrackedI;
    if (
      this.startTimeIsSetDeep() &&
      this.startTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startTimeIsSet = true;
      cloned.startTime = this.startTime;
    } else {
      //cloned.startTimeIsSet = false
    }
    if (
      this.endTimeIsSetDeep() &&
      this.endTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endTimeIsSet = true;
      cloned.endTime = this.endTime;
    } else {
      //cloned.endTimeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): GuidedSailTimeSlotTrackedI {
    if (!this.startTimeApplyFilter(filter)) this.startTimeIsSet = false;

    if (!this.endTimeApplyFilter(filter)) this.endTimeIsSet = false;

    return this;
  }
  startTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailTimeSlotMeta.startTime,
      GuidedSailTimeSlotMeta,
      this.startTime,
      this,
    );
  }
  startTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startTimeIsSet && this.startTimeApplyFilter(filter)) return true;

    return false;
  }
  endTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailTimeSlotMeta.endTime,
      GuidedSailTimeSlotMeta,
      this.endTime,
      this,
    );
  }
  endTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endTimeIsSet && this.endTimeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.startTimeIsSetDeep(filter)) return true;
    if (this.endTimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
